import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";

import { formatUpperCase } from "../../../../utils/formats";

const InformacoesAdicionaisSection = (props) => {
  const { proposalCompleteRegistrationLoading, observacoes } = props;

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            height={observacoes ? 150 : undefined}
            justify="flex-start"
            align="flex-start"
            label="Observações"
            value={formatUpperCase(observacoes)}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default InformacoesAdicionaisSection;
